/**
 * Product Constants - Fashion Industry Shop Filters
 * Migrated from kuttos reference project
 */

// Size systems for different regions
export const SIZE_SYSTEMS = {
  // Clothing Sizes
  International: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  UK: ["6-8", "8-10", "10-12", "12-14", "14-16", "16-18", "18-20", "20-22", "22-24"],
  USA: ["2-4", "4-6", "6-8", "8-10", "10-12", "12-14", "14-16", "16-18", "18-20"],
  TURKEY: ["34-36", "36-38", "38-40", "40-42", "42-44", "44-46", "46-48", "48-50", "50-52"],
  CHINA: ["40-42", "42-44", "44-46", "46-48", "48-50", "50-52", "52-54", "54-56", "56-58"],
  "Pants Waist (in)": ["24-26", "26-28", "28-30", "30-32", "32-34", "34-36", "36-38", "38-40", "40-42"],
  "Pants Length (in)": ["28", "30", "32", "34", "36", "38", "40"],
  
  // Shoe Sizes
  "Shoes US Men": ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14", "15"],
  "Shoes US Women": ["5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12"],
  "Shoes UK": ["3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
  "Shoes EU": ["35", "35.5", "36", "36.5", "37", "37.5", "38", "38.5", "39", "39.5", "40", "40.5", "41", "41.5", "42", "42.5", "43", "44", "45", "46"],
  
  // Specialty Sizing
  "One Size Fits All": ["One Size"],
  "Free Size": ["Free Size"],
  "Adjustable": ["Adjustable"],
};

// Product attribute options
export const COLOR_OPTIONS = [
  "Black", "Red", "Blue", "Yellow", "Orange", "Green", "White", "Cream", "Pink",
  "Khaki", "Multi colored", "African Prints", "Grey", "Silver", "Gold", "Brown",
  "Transparent", "Tan", "Nude", "Burgundy", "Olive", "Navy", "Purple", "Beige"
];

export const OCCASION_OPTIONS = [
  "Everyday Wear", "Sleepwear", "Birthday", "Church", "Holiday", "Workwear",
  "Smart casual", "Casual", "Formal", "Party", "Business", "Traditional wear",
  "Lounge wear", "Wedding", "Event", "Date night", "Weekend outing", "Safari ready",
  "Hiking", "Travel wear", "Brunch", "Leisure", "Lunch dates", "Club", "Photoshoots"
];

export const FITTING_OPTIONS = [
  "Slim fit", "Regular fit", "Loose fit", "Tailored fit", "Oversized",
  "Relaxed fit", "Muscle fit", "Snug fit", "Stretchy", "Backless", "Bodycon",
  "Draped fit", "A-line Fit", "Straight cut", "Flared fit", "Structured fit"
];

export const STYLE_OPTIONS = [
  "Chill wear", "Kitenge", "Afro-urban fusion", "Cultural formal", "Kanzu style",
  "Red carpet", "Sweat-optimized", "Sneakers-based outfits", "Training gear",
  "Activewear", "Bold prints", "Board room", "Statement pieces", "Minimalist modern",
  "Color block", "Weekend wear", "Everyday basics", "Classic", "Interview style",
  "Minimalist", "Vintage", "Boho", "Streetwear", "Luxury", "Afrocentric", "Sporty",
  "Edgy", "Tailored"
];

export const MATERIAL_OPTIONS = [
  "Cotton", "Linen", "Polyester", "Wool", "Denim", "Chiffon", "Silk", "Distressed",
  "Nylon", "Viscose", "Fleece", "Corduroy", "Leather", "Jersey", "Rayon", "Spandex",
  "Bamboo", "Knitted", "Satin", "Tweed", "Plastic", "Lace", "Tencel", "Neoprene",
  "Tulle", "Mesh", "Suede", "Organza", "Kitenge", "Ankara", "Metal", "Stainless steel",
  "Resin", "Velvet", "Raffia", "PU", "Canvas", "Beads"
];

// Filter options with "All" prefix
export const FILTER_COLORS = ["All", ...COLOR_OPTIONS];
export const FILTER_OCCASION_OPTIONS = ["All", ...OCCASION_OPTIONS];
export const FILTER_MATERIAL_OPTIONS = ["All", ...MATERIAL_OPTIONS];
export const FILTER_STYLE_OPTIONS = ["All", ...STYLE_OPTIONS];
export const FILTER_FITTING_OPTIONS = ["All", ...FITTING_OPTIONS];

// Default size system for filters
export const DEFAULT_SIZE_SYSTEM = "International";

// Function to get sizes for current system
export const getSizesForSystem = (system: string = DEFAULT_SIZE_SYSTEM): string[] => {
  return ["All", ...(SIZE_SYSTEMS[system as keyof typeof SIZE_SYSTEMS] || SIZE_SYSTEMS.International)];
};

// Get all available size systems
export const getAvailableSizeSystems = (): string[] => {
  return Object.keys(SIZE_SYSTEMS);
};

// Color mapping for UI display
export const COLOR_MAP: Record<string, string> = {
  Black: "#000000",
  White: "#FFFFFF",
  Gray: "#808080",
  Grey: "#808080",
  Navy: "#000080",
  Red: "#FF0000",
  Blue: "#0000FF",
  Green: "#008000",
  Yellow: "#FFFF00",
  Orange: "#FFA500",
  Purple: "#800080",
  Pink: "#FFC0CB",
  Brown: "#A52A2A",
  Beige: "#F5F5DC",
  Khaki: "#F0E68C",
  Cream: "#FFFDD0",
  "Multi colored": "#C0C0C0",
  "African Prints": "#C0C0C0",
  Silver: "#C0C0C0",
  Gold: "#FFD700",
  Transparent: "#FFFFFF",
  Tan: "#D2B48C",
  Nude: "#EDC9AF",
  Burgundy: "#800020",
  Olive: "#808000",
};
